import React from 'react';
import { useParams } from 'react-router-dom';

export default function TilesDeliveryOrderDiscount() {
  const deliveryOrderId = useParams().id;
  const url = `https://rlugroup.in/pdf/convert?fileName=rlugroup-tiles-delivery-order-discount.hbs&id_field=doNumber&format=A5&margintop=0.2cm&url=${process.env.REACT_APP_API_BASE_URL}/tiles/delivery-orders/details-with-discount/${deliveryOrderId}`;
  
  return (
    <object 
      data={url} 
      type="application/pdf" 
      width="100%" 
      height={window.innerHeight} 
      aria-label="Tiles Delivery Order PDF with Discount"
    >
      Tiles Delivery Order PDF with Discount
    </object>
  );
}